// src/config/config.js
export const API_URL = 'https://backupteamsapis.ue.r.appspot.com/api/'; // prod google
//export const API_URL = 'http://localhost:4000/api/'; // local

export const GIF_LOAD = 'https://i.pinimg.com/originals/c3/ef/e3/c3efe3c72dc3a0d598735ca29822e80a.gif'; //Clefairy

export const SUN_ICON = 'https://www.pokemon.com/static-assets/content-assets/cms2/img/pokedex/full/338.png';
export const MOON_ICON = 'https://www.pokemon.com/static-assets/content-assets/cms2/img/pokedex/full/337.png';
export const UNOW_ICON = 'https://images.wikidexcdn.net/mwuploads/wikidex/9/92/latest/20230319124508/Unown_%3F_icono_HOME.png';
export const NOTT_ICON = 'https://images.wikidexcdn.net/mwuploads/wikidex/0/0c/latest/20200721110217/Chingling.png';